<template>
  <SfScrollable
    v-if="isMobile"
    :active-index="activeIndex"
    direction="horizontal"
    wrapper-class="ml-[calc(-50vw+50%)] w-screen"
    is-active-index-centered
    buttons-placement="none"
    class="pointer-events-auto mt-6 size-full snap-x snap-mandatory bg-neutral-50 [-ms-overflow-style:none] [scrollbar-width:none] mobile:w-full
      [&::-webkit-scrollbar]:hidden"
  >
    <div
      v-for="{ key, options } in benefits"
      :key="key"
      class="relative m-0 size-full shrink-0 grow basis-full snap-center px-2 py-6"
    >
      <p class="pointer-events-auto flex size-full justify-center text-sm">
        <KikIcon
          icon="check"
          size="sm"
          class="mb-1 mr-2 fill-positive-600"
        />
        {{ $t(key, options) }}
      </p>
    </div>
  </SfScrollable>
  <section
    v-else
    class="mt-6 flex justify-center gap-8 bg-neutral-50 px-2 py-6 mobile:justify-start mobile:overflow-y-auto mobile:text-center"
    tabindex="0"
  >
    <div
      v-for="{ key, options } in benefits"
      :key="key"
    >
      <p class="text-sm mobile:w-[88vw]">
        <KikIcon
          icon="check"
          size="sm"
          class="mb-1 mr-2 fill-positive-600"
        />
        {{ $t(key, options) }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { SfScrollable } from '@storefront-ui/vue';

const { $domain } = useNuxtApp();
const { isMobile } = useDevice();

const activeIndex = ref(0);

const benefits = [
  { key: 'Purchase on invoice' },
  { key: 'days right of return', options: { days: $domain.maxAllowedDaysToReturn } },
  { key: 'Fast delivery' },
];

onMounted(() => {
  if (isMobile) {
    setInterval(() => {
      activeIndex.value = (activeIndex.value + 1) % benefits.length;
    }, 3000);
  }
});
</script>
